import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "../../redux/supervisorSlice";
import { selectionTypes } from "../utils/consts";
import WidgetTools from "./widgetTools";
import { PieChart, Series, Size, Connector, Legend } from 'devextreme-react/pie-chart';

function OutgoingCallsSummary(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [attended, setAttended] = useState(0);
    const [missed, setMissed] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`OutgoingCallsSummary_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [callsPercentage, setCallsPercentage] = useState([]);
    const [attendedPercentage, setAttendedPercentage] = useState(0);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send(`/app/unsubscribe/outgoingcallssummary`, {}, JSON.stringify({
                    token: props.token,
                    widgetId: props.identifier
                }));

                MonitorWSService.stompClient.unsubscribe(`outgoingcallssummary_${props.identifier}`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let groupId = parseInt(localStorage.getItem(`OutgoingCallsSummary_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId)
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/outgoingcallssummary_${props.identifier}/`, function (callssummary) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    var data = JSON.parse(callssummary.body);
                    setAll(prev => prev === data.totalCalls ? prev : data.totalCalls);
                    setAttended(prev => prev === data.answeredCalls ? prev : data.answeredCalls);
                    setMissed(prev => prev === data.missedCalls ? prev : data.missedCalls);
                    setAttendedPercentage(prev => prev === data.answeredCallsPercentage ? prev : data.answeredCallsPercentage);
                    setCallsPercentage(prev => {
                        const newCalls = [
                            { state: t("answered"), amount: data.answeredCallsPercentage },
                            { state: t("missed"), amount: data.missedCallsPercentage }
                        ];
                        const same = prev.length === newCalls.length && prev.every((v, i) => v.state === newCalls[i].state && v.amount === newCalls[i].amount);
                        return same ? prev : newCalls;
                    });
                }
            }, { id: `outgoingcallssummary_${props.identifier}` });

            MonitorWSService.stompClient.send("/app/subscribe/outgoingcallssummary", {}, JSON.stringify({
                token: props.token,
                widgetId: props.identifier,
                groupId: groupId
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroup = (groupId, groupName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        localStorage.setItem(`OutgoingCallsSummary_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`OutgoingCallsSummary_groupName_${props.identifier}_user${props.id}`, groupName);
        MonitorWSService.stompClient.send("/app/subscribe/outgoingcallssummary", {}, JSON.stringify({
            token: props.token,
            groupId: groupId,
            widgetId: props.identifier
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const customizePoint = (e) => {
        if (e.argument === t("answered")) {
            return {
                color: "#50cd89"
            }
        }
        if (e.argument === t("missed")) {
            return {
                color: "#f1416c"
            }
        }
    }

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} >
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-arrow-up-right")} /> {t("outgoingcalls")} - {groupName}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col lg={3} md={3} sm={3} xs={3}>
                        <div className="fs-3hx fw-bold text-gray-800 text-center">{all}</div>
                        <div className="fs-5 fw-semibold mb-7 text-center">{t("total")}</div>
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={3}>
                        <div className="fs-3hx fw-bold text-success text-center">{attended}</div>
                        <div className="fs-5 fw-semibold mb-7 text-center">{t("attended")}</div>
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={3}>
                        <div className="fs-3hx fw-bold text-danger text-center">{missed}</div>
                        <div className="fs-5 fw-semibold mb-7 text-center">{t("missed")}</div>
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={3}>
                        <PieChart
                            id="outoingpercentage"
                            dataSource={callsPercentage}
                            type="doughnut"
                            resolveLabelOverlapping="shift"
                            innerRadius={0.8}
                            customizePoint={customizePoint}
                            rtlEnabled={props.rtl}
                            centerRender={(pie) => {
                                return (
                                    <svg>
                                        <text textAnchor="middle" x="70" y="70" style={{ fontSize: 18, fill: localStorage.getItem("faTheme") === "light" ? '#3f4254' : "#cdcdde" }}>
                                            <tspan x="100" style={{ fontWeight: 600, fontSize: "30px" }}>{attendedPercentage}%</tspan>
                                        </text>
                                    </svg>
                                );
                            }}
                        >
                            <Size
                                height={110}
                                width={130}
                            />
                            <Series
                                argumentField="state"
                                valueField="amount"
                            >
                                <Connector visible={true}></Connector>
                            </Series>
                            <Legend visible={false}></Legend>
                        </PieChart>
                    </Col>
                </Row>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroup={setGroup} groupId={groupId} groupName={groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { removeWidget })(OutgoingCallsSummary);